import { Component, OnInit, Input } from '@angular/core';
import { removeAnItem, removeAnItens, mapArrayByProperties, isEquals } from '@shared/utils/util';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SystemFieldService } from '@app/services/system-field/system-field.service';
import { LoaderService } from '../loader/loader.service';

@Component({
  selector: 'app-edit-form-multivalue',
  templateUrl: './edit-form-multivalue.html',
  styleUrls: ['./edit-form-multivalue.scss']
})
export class EditFormMultivalueComponent implements OnInit {

  @Input() dateFields;
  @Input() dateField;
  @Input() editorMode;

  public formulario: FormGroup;

  constructor(
    private formBuilder: FormBuilder
  ) {  
  }

  get f() { return this.formulario.controls; }

   initFormulario() {
    this.formulario = this.formBuilder.group({
      min_multivalued_options: [this.dateField.min_multivalued_options ?? null],
      max_multivalued_options: [this.dateField.max_multivalued_options ?? null],
    });

    this.formulario.valueChanges.subscribe((value)=> {
      if (value.min_multivalued_options > value.max_multivalued_options) {
        this.formulario.patchValue({max_multivalued_options: value.min_multivalued_options}, {emitEvent: false});
        this.dateField.min_multivalued_options = value.min_multivalued_options;
        this.dateField.max_multivalued_options = value.min_multivalued_options;
      } else {
        this.dateField.min_multivalued_options = value.min_multivalued_options;
        this.dateField.max_multivalued_options = value.max_multivalued_options;
      }
    });
   }

  ngOnInit(): void {
    this.initFormulario();
  }

}
